import React from "react";
import Svg, { Defs, LinearGradient, Stop, G, Path, Circle, Ellipse
  } from "react-native-svg"

function Add(props){
    const { color } = props;

  return  (
    <Svg
      width={31}
      height={32}
      viewBox="0 0 31 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G
        transform="translate(1.737 2)"
        stroke={color}
        strokeWidth={2.79}
        fill="none"
        fillRule="evenodd"
      >
        <Ellipse cx={13.754} cy={14} rx={13.754} ry={14} />
        <G strokeLinecap="round" strokeLinejoin="round">
          <Path d="M13.754 7v13M7.406 14.091h12.696" />
        </G>
      </G>
    </Svg>
  )
}

Add.defaultProps = {
  width: 30,
  height: 30,
}

export default Add


